import { Component, OnInit } from "@angular/core";
import { IPartner } from "src/app/Models/IPartner";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;

@Component({
  selector: "app-partnier",
  templateUrl: "./partnier.component.html",
  styleUrls: ["./partnier.component.scss"]
})
export class PartnierComponent implements OnInit {
  lang: string;
  url: string;
  data: IPartner[];

  constructor(private base: BaseService) {
    this.url = this.base.url;
    this.data = new Array<IPartner>();
  }

  ngOnInit() {
    this.lang = this.base.getLang();

    this.data.push({
      title: { en: "Microsoft", ar: "مايكروسوفت" },
      isActive: true,
      image: "assets/images/Partiner/Microsoft_logo.svg"
    });

    this.data.push({
      title: { en: "Oracle", ar: "اوركل" },
      isActive: true,
      image: "assets/images/Partiner/Oracle_logo.svg"
    });

    this.data.push({
      title: { en: "MTN", ar: " ام تي إن" },
      isActive: true,
      image: "assets/images/Partiner/MTN_Logo.svg"
    });

    if (this.data.length > 0) {
      $(document).ready(function () {
        $(".partiner-logos").slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          rtl: true,
          autoplay: true,
          autoplaySpeed: 1500,
          lazyLoad: "progressive",
          arrows: false,
          dots: true,
          centerPadding: "60px",
          pauseOnHover: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 1
              }
            }
          ]
        });
      });
    } else {
      $(".partiner").hide();
    }
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
    if (this.lang == "en") {
      $(
        ".slick-prev, .slick-next, .slick-dots, .slick-dots li button:before"
      ).css("direction", " ltr");
    } else {
      $(".slick-dots, .slick-dots li button:before").css("direction", " rtl");
    }
  }

  onLoading(id) {
    $("#" + id).fadeOut("slow");
  }
}
